<template>
  <div class="sign_view">
    <template v-if="details.matchName">
      <main :style="{width:isOtherBall?'100%':'1050px'}" id="prints">
        <div style="padding:30px 0 0 0" :class="[info.project === 9?'athletics_box':'']">
          <h1 style="text-align:center;font-weight:normal;font-size:24px;">{{details.matchName}}报名表</h1>
          <div class="info" :class="[info.project === 9?'athletics_info':'info']" v-if="!isOtherBall">
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;justify-content:flex-start;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>校</span>
                  <span>名：</span>
                </p>
                <span class="info_text rights">{{details.schoolName}}</span>
              </section>
              <section
                style="flex:1;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;flex-shrink: 0;"
              >
                <span class="info_title" style="width:60px">{{info.project === 9?'团 长：':'组 别：'}}</span>
                <span class="info_text">{{info.project === 9?details.teamLeader:details.groupText}}</span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>领</span>
                  <span>队：</span>
                </p>
                <span class="info_text" style="width:260px;">{{details.leaderName}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width:90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;">{{details.leaderPhone}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:60px;">邮 箱：</span>
                <span class="info_text" style="width:220px">{{details.leaderEmail}}</span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>主</span>
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="width:260px;">{{details.headCoachName}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;">{{details.headCoachPhone}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:60px">邮 箱：</span>
                <span class="info_text" style="width:220px">{{details.headCoachEmail}}</span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;justify-content:flex-start;"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" :style="{minWidth:info.project === 9?'372px':'260px'}">{{details.coachNames}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:90px">工作人员：</span>
                <span class="info_text" style="min-width:120px">{{details.workerNames}}</span>
              </section>
            </div>
          </div>
          <div class="info smallball_info" v-else>
            <div
              class="info_row smallball_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;margin-bottom:10px"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>校</span>
                  <span>名：</span>
                </p>
                <span class="info_text rights">{{getSchoolName}}</span>
              </section>
              <section
                style="flex:1;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:60px">组 别：</span>
                <span class="info_text">{{details.groupText}}</span>
              </section>
            </div>
            <div
              class="info_row smallball_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;margin-bottom:10px"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>领</span>
                  <span>队：</span>
                </p>
                <span class="info_text" style="width:260px;">{{details.leaderName}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width:90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;">{{details.leaderPhone}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:60px;">邮 箱：</span>
                <span class="info_text" style="width:220px">{{details.leaderEmail}}</span>
              </section>
            </div>
            <div
              class="info_row smallball_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;margin-bottom:10px"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>主</span>
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="width:260px;">{{details.headCoachName}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;">{{details.headCoachPhone}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:60px">邮 箱：</span>
                <span class="info_text" style="width:220px">{{details.headCoachEmail}}</span>
              </section>
            </div>
            <div
              class="info_row smallball_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;margin-bottom:10px"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" :style="{width:isPrintOrPdf === 'print'?'288px':'260px'}" >{{details.coachNames}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:90px">工作人员：</span>
                <span class="info_text" style="width:230px;">{{details.workerNames}}</span>
              </section>
              <section
                v-if="isOtherBall"
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:60px">住 宿：</span>
                <span
                  class="info_text"
                  style="width:220px;"
                >男 {{details.stayMan}}，女 {{details.stayWoman}}（人）</span>
              </section>
            </div>
          </div>
          <div class="table_list">
            <template v-if="info.project !== 7 && info.project !== 9 && !isOtherBall">
              <table
              class="unit"
              cellpadding="0"
              cellspacing="0"
              v-for="(item,index) in getTableList"
              :key="item"
              :class="(index + 1) % 4 === 0?'page_break':''"
              :style="{pageBreakAfter:(index + 1) % 3 === 0 || (getTableList < 3 && (index+1) === getTableList) || ((index + 1) / 3 !== parseInt((index + 1)/3) && (index+1) === getTableList)?'always':''}"
            >
              <tbody>
                <tr v-for="(temp,num) in columns" :key="index + '_' + num">
                  <td
                    :style="{borderRight:'none',borderBottom:num === (columns.length - 1)?'1px solid #222':'none'}"
                    style="border:1px solid #222;
                padding: 12px 0;
                min-width: 0;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;"
                  >
                    <div
                      style="box-sizing: border-box;
                    overflow: hidden;
                    width:100px;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;"
                    >{{temp.name}}</div>
                  </td>
                  <template v-for="(i,n) in details.athleteList.slice(index * 5,(index + 1) * 5)">
                    <td
                      :style="{borderRight:n === 4?'1px solid #000':'none',borderBottom:num === (columns.length - 1)?'1px solid #222':'none'}"
                      style="border:1px solid #222;padding: 12px 0;
                min-width: 0;
                width:240px;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;"
                      :key="index + '_' + num + n"
                    >
                      <div
                        style="box-sizing: border-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;"
                      >{{temp.key === 'heightAndWeight'?(!i['height'] && !i['weight'])?'':(i['height'] + 'cm/' + i['weight'] + 'kg'):temp.key === 'startSchoolDate'?(!i[temp.key]?'':formatTime(i[temp.key])):i[temp.key]}}</div>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
            </template>
            <template v-else-if="isOtherBall">
              <table
                style="margin-bottom:20px;width:100%;page-break-after:always;"
                class="foot_table"
                cellpadding="0"
                cellspacing="0"
              >
                <thead>
                  <th>序号</th>
                  <th>姓名</th>
                  <th>性别</th>
                  <th>民族</th>
                  <th>学号</th>
                  <th>入学时间</th>
                  <th>注册号码</th>
                  <th>电话号码</th>
                  <th>团体</th>
                  <th>男单</th>
                  <th>女单</th>
                  <th>男双</th>
                  <th>女双</th>
                  <th style="border-right:1px solid #000!important">混双</th>
                </thead>
                <tbody>
                  <tr v-for="(temp,num) in details.athleteList" :key="num">
                    <td
                      style="width:60px;"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{num+1}}</div>
                    </td>
                    <td
                      style="width:100px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.athleteName}}</div>
                    </td>
                    <td
                      style="width:60px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.genderText}}</div>
                    </td>
                    <td
                      style="width:80px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.nation}}</div>
                    </td>
                    <td
                      style="width:100px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.studentNumber}}</div>
                    </td>
                    <td
                      style="width:100px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{formatTime(temp.startSchoolDate)}}</div>
                    </td>
                    <td
                      style="width:200px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.registerNumber}}</div>
                    </td>
                    <td
                      style="width:120px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.athletePhone}}</div>
                    </td>
                    <td
                      style="width:70px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.projectJson?temp.projectJson.smallBallGroup:''}}</div>
                    </td>
                    <td
                      style="width:70px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.projectJson?temp.projectJson.smallBallSingles1:''}}</div>
                    </td>
                    <td
                      style="width:70px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.projectJson?temp.projectJson.smallBallSingles0:''}}</div>
                    </td>
                    <td
                      style="width:70px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.projectJson?temp.projectJson.smallBallDoubles1:''}}</div>
                    </td>
                    <td
                      style="width:70px"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.projectJson?temp.projectJson.smallBallDoubles0:''}}</div>
                    </td>
                    <td
                      style="width:70px;border-right:1px solid #000!important;"
                      :style="{borderBottom:num === details.athleteList.length - 1?'1px solid #000!important':'none'}"
                    >
                      <div>{{temp.projectJson?temp.projectJson.smallBallMixed:''}}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
            <template v-else-if="info.project === 9">
              <table
                style="margin-bottom:20px;width:100%;page-break-after:always;"
                class="foot_table athletics_table"
                cellpadding="0"
                cellspacing="0"
              >
                <thead>
                <th style="width:25px">序号</th>
                <th>组别</th>
                <th>性别</th>
                <th>姓名</th>
                <th>注册号码</th>
                <th>
                  <p>项目一</p>
                  <p class="last_row">（单项）</p>
                </th>
                <th>
                  <p>项目二</p>
                  <p class="last_row">（单项）</p>
                </th>
                <th>
                  <p>项目三</p>
                  <p class="last_row">（接力）</p>
                </th>
                <th>
                  <p>项目四</p>
                  <p class="last_row">（接力）</p>
                </th>
                <th>教练员</th>
                <th
                  style="border:1px solid #222;width: 100px; box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;position: relative;text-align: center;"
                >备注</th>
              </thead>
              <tbody>
                <tr v-for="(temp,num) in details.athleteList" :key="num">
                  <td style="width:25px;">
                    <div>{{num+1}}</div>
                  </td>
                  <td style="width:60px">
                    <div>{{temp.projectJson?temp.projectJson.athleticsGroup:''}}</div>
                  </td>
                  <td style="width:60px">
                    <div>{{temp.genderText}}</div>
                  </td>
                  <td style="width:100px">
                    <div>{{temp.athleteName}}</div>
                  </td>
                  <td style="width:120px">
                    <div>{{temp.registerNumber}}</div>
                  </td>
                  <td style="width:90px">
                    <div>{{temp.projectJson?temp.projectJson.athleticsIndividual1:''}}</div>
                  </td>
                  <td style="width:90px">
                    <div>{{temp.projectJson?temp.projectJson.athleticsIndividual2:''}}</div>
                  </td>
                  <td style="width:120px">
                    <div>{{temp.projectJson?temp.projectJson.athleticsRelay1:''}}</div>
                  </td>
                  <td style="width:120px">
                    <div>{{temp.projectJson?temp.projectJson.athleticsRelay2:''}}</div>
                  </td>
                  <td style="width:100px">
                    <div>{{temp.coachName}}</div>
                  </td>
                  <td style='border-right:1px solid #000!important;'>
                    <div>{{temp.remarks}}</div>
                  </td>
                </tr>
              </tbody>
              </table>
            </template>
            <template v-else>
              <table
                class="foot_table"
                cellpadding="0"
                cellspacing="0"
                style="width:100%;margin-bottom:20px;page-break-after:always;"
              >
                <thead>
                  <th>序号</th>
                  <th>姓名</th>
                  <th>入学时间</th>
                  <th>号码</th>
                  <th>位置</th>
                  <th>队员注册号</th>
                  <th>入学性质</th>
                  <th style="border-right:1px solid #222">备注</th>
                </thead>
                <tbody>
                  <template v-for="(i) in 26">
                    <tr v-if="i < 21" :key="i">
                      <td style="width:60px">
                        <div>{{i}}</div>
                      </td>
                      <td style="width:150px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].athleteName:''}}</div>
                      </td>
                      <td style="width:120px;">
                        <div>{{details.athleteList[i-1]?(details.athleteList[i-1].startSchoolDate?formatTime(details.athleteList[i-1].startSchoolDate):''):''}}</div>
                      </td>
                      <td style="width:60px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].signNumber:''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].position:''}}</div>
                      </td>
                      <td style="width:200px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].registerNumber:''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].sportsLevelText:''}}</div>
                      </td>
                      <td style="border-right:1px solid #222;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].remarks:''}}</div>
                      </td>
                    </tr>
                    <tr v-else-if="i === 21" :key="i + '_'">
                      <td colspan="8" style="border-right:1px solid #222;">
                        <div>以上20人为赛区确认名单，以下5人为递补名单。</div>
                      </td>
                    </tr>
                    <tr v-else :key="i + '-'">
                      <td
                        style="width:60px"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{i - 1}}</div>
                      </td>
                      <td
                        style="width:150px;"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].athleteName:''}}</div>
                      </td>
                      <td
                        style="width:120px;"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{details.athleteBenchList[i-22]?formatTime(details.athleteBenchList[i-22].startSchoolDate):''}}</div>
                      </td>
                      <td
                        style="width:60px;"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].signNumber:''}}</div>
                      </td>
                      <td
                        style="width:100px;"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].position:''}}</div>
                      </td>
                      <td
                        style="width:200px;"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].registerNumber:''}}</div>
                      </td>
                      <td
                        style="width:100px;"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].sportsLevelText:''}}</div>
                      </td>
                      <td
                        style="border-right:1px solid #222;"
                        :style="{borderBottom:i === 26?'1px solid #222!important':'none'}"
                      >
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].remarks:''}}</div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </template>
            <template v-if="isShowBottom">
              <div
                class="foots"
                v-if="details.state === 0"
                :class="getTableList % 3 === 0?'page_break':''"
                style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
              >
                <section
                  style="font-size:24px;display:flex;height:100%;flex-direction:column;align-items:center;justify-content:center"
                >
                  <p>报名未提交</p>
                </section>
              </div>
              <div
                class="foots"
                v-else
                :class="getTableList % 3 === 0?'page_break':''"
                style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
              >
                <p style="font-size:20px;">体育部意见：</p>
                <p
                  style="font-size:24px;text-align:center;margin-top:50px;"
                >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
              </div>
            </template>
          </div>
        </div>
        <athletesPhoto v-if="info.project !== 9 && !isOtherBall" ref="athletesPhoto" :details="tableData" :matchName="matchName"></athletesPhoto>
        <smallBallPhoto v-else-if="isOtherBall" ref="athletesPhoto" :details="tableData" :matchName="matchName"></smallBallPhoto>
        <athleticsPhoto v-else ref="athletesPhoto" :details="tableData" :matchName="matchName"></athleticsPhoto>
      </main>
    </template>
    <template v-else>
      <main id="prints">
        <div style="padding:30px 0 0 0">
          <h1 style="text-align:center;font-weight:normal;">{{details.matchName}}报名表</h1>
          <div class="info">
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>校</span>
                  <span>名：</span>
                </p>
                <span class="info_text" style="width:630px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title">组 别：</span>
                <span class="info_text"></span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>领</span>
                  <span>队：</span>
                </p>
                <span class="info_text" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title">邮 箱：</span>
                <span class="info_text"></span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>主</span>
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title">邮 箱：</span>
                <span class="info_text"></span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="min-width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:90px">工作人员：</span>
                <span class="info_text" style="min-width:120px"></span>
              </section>
            </div>
          </div>
          <div class="table_list">
            <div
              style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
            >
              <section
                style="font-size:24px;display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
              >
                <p>暂无数据</p>
              </section>
            </div>
          </div>
        </div>
        <athletesPhoto :details="tableData" :matchName="matchName"></athletesPhoto>
      </main>
    </template>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage";
import { signDetail, signList } from "@/api/sign-up-match";
import { method } from "@/utils/utils";
import athleticsPhoto from "./athletics-photo";
import athletesPhoto from "./athletes-photo";
import smallBallPhoto from "./smallBall-photo";
import { getMatchList } from "@/api/sports-management";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
  // 报名表查看
  components: {
    athletesPhoto,
    athleticsPhoto,
    smallBallPhoto
  },
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      isPrintOrPdf:"",
      isShowBottom: false,
      loading: null,
      showTableNum: 0,
      isShowBorder: true,
      isRender: false,
      matchList: [],
      switchType: 1,
      matchName: "",
      schoolList: [],
      details: {},
      tableData: {},
      userInfo: JSON.parse(getSession("userInfo")) || "",
      query: {
        year: new Date().getFullYear(),
        id: "",
        project:""
      },
      columns: [
        {
          key: "signNumber",
          name: "号码"
        },
        { key: "position", name: "位置" },
        { key: "athleteName", name: "姓名" },
        { key: "studentNumber", name: "学号" },
        { key: "startSchoolDate", name: "入学时间" },
        { key: "heightAndWeight", name: "身高、体重" },
        { key: "registerNumber", name: "队员注册号" }
      ]
    };
  },
  computed: {
        // 网球、羽毛球、乒乓球公用
    isOtherBall() {
      return (
        this.info.project === 1 ||
        this.info.project === 5 ||
        this.info.project === 6
      );
    },
    // 获取学校名称
    getSchoolName() {
      let str = "";
      this.schoolList.filter(item => {
        if (item.id === this.query.id) str = item.schoolName;
      });
      return str;
    },
    // 表格显示数量
    getTableList() {
      if (this.info.project === 7) {
        return;
      }
      if(this.info.project === 9) {
        return;
      }
      /**
       * 每个表格显示5项数据，如果数据小于5条，则使用空对象填充
       */
      let num = 0;

      if (this.details.athleteList && this.details.athleteList.length < 5) {
        let length = 5 - this.details.athleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.athleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (this.details.athleteList.slice((num - 1) * 5, num * 5).length < 5) {
          let length =
            5 - this.details.athleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.athleteList.push({});
          }
        }
      }
      this.showTableNum = num;
      return num;
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    }
  },
  watch: {
    info: {
      handler(value) {
        if (value) {
          Object.assign(this.query, {
            year: value.year,
            id: value.id,
            project:value.project
          });
          this.getSignDetail();
        }
      },
      deep: true
    }
  },
  methods: {
    // 导出pdf
    exportPdf() {
      var that = this;
      this.isPrintOrPdf = "pdf";
      document.documentElement.scrollLeft = 0;
      this.loading = this.$loading({
        lock: false,
        text: "PDF生成中...",
        spinner: "el-icon-loading"
      });
      that.isShowBottom = false;
      that.isShowBorder = false;
      let pageH =
        (document.querySelector("#prints").clientWidth / 595.28) * 841.89;
      let unit = document.querySelectorAll(".unit");
      unit.forEach((item, index) => {
        if ((index + 1) % 4 == 0) {
          item.style.marginTop = "220px";
        }
      });
      let photos = document.querySelector(".athletes_photos");
      photos.style.border = "none";
      photos.style.padding = "0 20px";
      if (unit.length <= 3) {
        switch (unit.length) {
          case 1:
            photos.style.marginTop = 300 * 3 + "px";
            break;
          case 2:
            photos.style.marginTop = 270 * 2 + "px";
            break;
          default:
            photos.style.marginTop = 160 * 1 + "px";
            break;
        }
      } else {
        switch (unit.length % 3) {
          case 1:
            photos.style.marginTop = 360 * 3 + "px";
            break;
          case 2:
            photos.style.marginTop = 360 * 2 + "px";
            break;
          default:
            photos.style.marginTop = 360 * 1 + "px";
            break;
        }
      }
      let rows = document.querySelectorAll(".rows");
      rows.forEach((item, index) => {
        if ((index + 1) % 5 == 0 && index !== 0) {
          item.style.marginTop = "220px";
          item.style.borderTop = "1px solid #999";
        }
      });
      let leftBorder = document.querySelectorAll(".left_border");
      leftBorder.forEach((item, index) => {
        item.style.borderLeft = "1px solid #999";
      });
      let exportPdfRight = document.querySelectorAll(".export_pdf_right");
      exportPdfRight.forEach((item, index) => {
        item.style.borderRight = "1px solid #999";
      });
      let exportPdfBottom = document.querySelectorAll(".export_pdf_bottom");
      exportPdfBottom.forEach((item, index) => {
        item.style.borderBottom = "1px solid #999";
      });
      this.$nextTick(() => {
        html2Canvas(document.querySelector("#prints"), {
          allowTaint: true,
          dpi: 192,
          useCORS: true
        }).then(canvas => {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 842;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(that.details.matchName + ".pdf");
          that.loading.close();
          photos.style.border = "1px solid #999";
          photos.style.padding = "0";
          photos.style.marginTop = "0";
          unit.forEach((item, index) => {
            if ((index + 1) % 4 == 0) {
              item.style.marginTop = "20px";
            }
          });
          rows.forEach((item, index) => {
            if ((index + 1) % 5 == 0 && index !== 0) {
              item.style.marginTop = "0";
              item.style.borderTop = "none";
            }
          });
          leftBorder.forEach((item, index) => {
            item.style.borderLeft = "none";
          });
          exportPdfRight.forEach((item, index) => {
            item.style.borderRight = "none";
          });
          exportPdfBottom.forEach((item, index) => {
            item.style.borderBottom = "none";
          });
          that.isShowBorder = true;
          that.isShowBottom = true;
        });
      });
    },
    //
    getShowTableNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 5) {
        let length = 5 - this.details.athleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.athleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (this.details.athleteList.slice((num - 1) * 5, num * 5).length < 5) {
          let length =
            5 - this.details.athleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.athleteList.push({});
          }
        }
      }
      return num;
    },
    // 打印
    print() {
      this.isPrintOrPdf = "print";
      this.isShowBottom = false;
      this.$nextTick(() => {
        var el = document.querySelector("#prints"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        // doc.write(
        //   '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 10mm;} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 15px 0} .foots {margin-top:20px} .info {margin-bottom:20px} table {margin-top:30px;color:#000} table tr td {padding:8px 0!important} main {margin:15mm 0} h1 { margin:5mm 0 40px 0 } span.rights {width:560px}</style></head><body style="zoom: 80%;">' +
        //     el.innerHTML +
        //     "</body></html>"
        // );
        doc.write(
          '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 10mm;} .print_box_border {border:1px solid #999;border-top:none;border-bottom:none} .margin_top {margin-top:20mm!important} .top_border {border-top:1px solid #999!important} .left_border {border-left:1px solid #999!important} .bottom_border {border-bottom:1px solid #999!important} .right_border {border-right:1px solid #999!important;} .athletes_photos {margin-top:15mm!important;border:none!important} .headers{margin-top:5mm!important;padding-top:0!important;border-bottom:none!important} .foot_table {color:rgb(68, 68, 68)!important;font-weight:normal;font-size:14px} .foot_table thead th,.foot_table tbody td {border-bottom:none!important} .foot_table thead th,.foot_table tbody td {font-weight:normal;color:rgba(68,68,68,1);border: 1px solid #222;border-right:none;padding: 6px 0;min-width: 0;box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;position: relative;text-align: center;} foot_table tbody td  {border-top:none} .fonts_color {color:#000} .athlete_info {font-size:16px!important;margin-bottom:6px!important} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 15px 0} .foots {margin-top:20px} .info {margin-bottom:20px} table {margin-top:30px;color:#000} table tr td {padding:8px 0!important} main {margin:15mm 0} h1 { margin:5mm 0 40px 0 } span.rights {width:560px}' + 
          '.athletics_table thead th,.athletics_table tbody td {padding:4px 0!important}'+ '.athletics_table tbody td {border-bottom:1px solid #000!important}' +
          '.athletics_table thead th p {margin:0;padding;0!important}' + '.athletics_table thead th p.last_row {margin-top:6px!important;}' +  
          '.athletics_info .info_row {margin:0 0 5px 0;font-size:16px!important;}' + '.athletics_box h1 {margin-bottom:20px!important}' +
          '.custom_width {width:11.1%!important;} .small_ball_custom_width {width:12.5%!important}' + 
          '</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
            setTimeout(()=>{
              
            this.isShowBottom = true;
            },500)
        };
        // iframe.contentWindow.print();
      });
    },
    // 获取详情数据
    getSignDetail(id = this.query.id) {
      signDetail({ id,project:this.query.project })
        .then(res => {
          if (this.info.project === 7) {
            let arr = [];
            let newArr = [];
            for (let i = 0; i < 25; i++) {
              if (i < 20) {
                arr.push(res.athleteList[i] ? res.athleteList[i] : {});
              } else {
                arr.push(
                  res.athleteBenchList[i - 20]
                    ? res.athleteBenchList[i - 20]
                    : {}
                );
              }
            }
            newArr = [...res.athleteList, ...res.athleteBenchList];
            let length = newArr.length;
            for (let i = 0; i < 25 - length; i++) {
              newArr.push({});
            }
            res.athletePhotoList = newArr;
            res.athleteList = arr;
          }
          
          this.details = res;
          this.tableData = JSON.parse(JSON.stringify(res));
          this.isRender = true;
        })
        .catch(err => {});
    },
    // 切换按钮组
    selectType(type) {
      this.switchType = type;
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.sign_view {
  > .query_wapper {
    margin: 0 0 0 10px;
  }
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }
  > main {
    width: 1050px;
    // border: 1px solid #ddd;
    margin: 0 auto;
    h1 {
      font-size: 24px;
      color: #444;
      text-align: center;
    }
    .info {
      margin: 40px 0;
      padding: 0 20px;
      > div {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #444;
        margin-bottom: 20px;
        .rights {
          width: 630px;
        }
        > section {
          margin-right: 20px;
          display: flex;
          align-items: center;
          > .first_title {
            width: 80px;
            display: flex;
            justify-content: space-between;
          }
          > .info_text {
            font-size: 18px;
          }
        }
      }
    }
    .smallball_info {
    width:90%;
    .rights {
      width:950px!important;
    }
  }
  .smallball_row {
    justify-content: space-between;
  }
    .table_list {
      padding: 0 20px;
      > table {
        margin-bottom: 20px;
      }
    }
  }
    .foot_table {
    thead th {
      border: 1px solid #222;
      padding: 6px 0;
      min-width: 0;
      box-sizing: border-box;
      text-overflow: ellipsis;
      vertical-align: middle;
      position: relative;
      text-align: center;
    }
    tbody {
      td {
        font-size: 14px;
        border: 1px solid #222;
        padding: 6px 0;
        min-width: 0;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        text-align: center;
        div {
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          line-height: 23px;
          padding-left: 10px;
          padding-right: 10px;
        }
      }
    }
  }
}
</style>